import React, { FC, PropsWithChildren } from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from '../../keycloak';
import { BoldText } from "../atoms/texts/BoldText";


interface AuthenticationProviderProps {
}

export const AuthenticationProvider: FC<AuthenticationProviderProps & PropsWithChildren> = (props) => {
        // "enable-cors": true
    // checkLoginIframe (keycloak-js default: true) polls the IAM login-status iframe
    // every ~5s. Modern browsers block third-party cookies, so that cross-origin check
    // wrongly reports the SSO session as gone, fires onAuthLogout -> the app renders
    // <Login/> -> keycloak.login() redirects to IAM and immediately back, re-authenticating.
    // The net effect is a full page reload every few seconds. Disabling it stops the loop
    // (we don't rely on cross-tab single-logout detection here).
    const initOptions = { pkceMethod: 'S256', checkLoginIframe: false }

    console.log('QQQ AuthenticationProvider: ');



    const loadingComponent = (
        <BoldText></BoldText>
    )

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={initOptions}
            LoadingComponent={loadingComponent}>
            {props.children}
        </ReactKeycloakProvider>)
};
